<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3">
                <LeafletComponent
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import { Popover } from 'bootstrap';

export default {
    props: ['plazas', 'recinto_id', 'evento_id', 'sesion_id'],
    data() {
        return {
            svg_loaded : '',
            loading: true,
            svgpanzoom: null,
            svg: null,
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            ocupadaColor: 'red', 
            seleccionadaColor: '#8CA9D9',
            bloqueadaColor: '#BF95C4', 
            enSesionColor: 'yellow', 
            vendidaAbonosColor: 'black',
            vendidaEventosColor: 'red',
            bloqueadaAbonoColor: 'purple', 
            enSesionEventosColor: 'orange', 
            abonadoNoRenovadoColor: '#B05D04',
            svgRendered: null,
            isPanning: false
        }            
    },
    created() {
        this.getSvg();        
    },
    methods: {
        getSvg() {
            this.loading = true;
            const params = {
                recinto_id: this.recinto_id
            };
            this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                .then(({ data: { svg } }) => {
                    this.renderLeafletSvg(svg);
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    console.warn('Error al recuperar el SVG del recinto anexo');
                });
        },
        renderLeafletSvg(svg) {
            const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;

            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');

            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                if (plaza) {
                    const title = this.getButacaName(plaza);
                    if (plaza.libre && !plaza.ocupada.bloqueada) {     
                        this.drawPopover(circle, plaza, title);      
                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s';
                        circle.setAttribute('fill', this.originalColor);

                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(plaza.id);
                                }
                            }, 150);
                        });                    
                    } else {
                        if (plaza.ocupada.bloqueada) {
                            if (plaza.info_ocupada.concepto) {
                                new Popover(circle, {
                                    html: true,
                                    title: title,
                                    content: '<div><strong>Concepto: </strong>' + plaza.info_ocupada.concepto + '</div>',
                                    trigger: 'hover'
                                });
                            }
                            this.drawPopover(circle, plaza, title);      
                            circle.setAttribute('fill', this.bloqueadaColor);
                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.bloqueadaColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(plaza.id);
                                    }
                                }, 150);
                            }); 
                        }
                        else if (plaza.ocupada && plaza.ocupada.sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionEventosColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.bloqueadaAbonoColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaAbonosColor);
                            circle.style.cursor = 'not-allowed';

                            let content

                            if (plaza.info_ocupada.numero_pedido) {
                                circle.style.cursor = 'pointer';
                                content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                circle.addEventListener('click', () => {
                                    let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/entradas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                    window.open(url, '_blank');
                                });
                            }
                            this.drawPopover(circle, plaza, title, content); 
                        } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.abonadoNoRenovadoColor);
                            circle.style.cursor = 'not-allowed';

                            let content

                            if (plaza.info_ocupada.numero_pedido) {
                                circle.style.cursor = 'pointer';
                                content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                circle.addEventListener('click', () => {
                                    let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/entradas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                    window.open(url, '_blank');
                                });
                            }
                            this.drawPopover(circle, plaza, title, content); 
                        }  else if (plaza.ocupada && plaza.ocupada.en_sesion_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.enSesionColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }
                    }
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },
        drawPopover(circle, plaza, title = null, content = '') {

            if (plaza.ocupada) {
                if (plaza.ocupada.bloqueada) {
                    content += `<div><strong>Plaza bloqueada</strong></div>`;
                }
                if (plaza.ocupada.venta) {
                    content += `<div><strong>Vendida</strong></div>`;
                }
                if (plaza.ocupada.sesion) {
                    content += `<div><strong>En sesión</strong></div>`;
                }
                if (plaza.ocupada.comprada_abonos) {
                    content += `<div><strong>Vendida en abono</strong></div>`;
                }
                if (plaza.ocupada.bloqueada_abonos) {
                    content += `<div><strong>Bloqueada en abonos</strong></div>`;
                }
                if (plaza.ocupada.en_sesion_abonos) {
                    content += `<div><strong>En sesión en abono</strong></div>`;
                }
                if (plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                    content += `<div><strong>Abonado no renovado</strong></div>`;
                }
            }

            if (plaza.libre) {
                content = `<div><strong>Plaza libre</strong></div>`;
            }

            const popoverOptions = {
                title: title,
                content: content,
                trigger: 'hover',
                html: true
            };

            new Popover(circle, popoverOptions);
        },

        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(butaca) {
            const nButaca = butaca.butaca;
            const nFila = butaca.fila;
            const sector = butaca.sector_name;

            if (sector) {
                return `Sector: ${sector} - Fila: ${nFila} - Butaca: ${nButaca}`;
            }

            return `Fila: ${nFila} - Butaca: ${nButaca}`;
        },

        clickButaca(plaza_id) {
            let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
            if (plaza) {
                this.$emit('clickPlaza', plaza);
            }
        },
    },
    components: { LeafletComponent }
}
</script>